import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { RegionFeatureStatus } from '../../shared/region-feature-status.model';
import { ModalService } from '../../../shared/services/modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-region-feature',
  templateUrl: './region-feature.component.html',
  styleUrls: ['./region-feature.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class RegionFeatureComponent implements OnInit, OnChanges {

  @Input()
  labelNode: string;

  @Input()
  groupName: string;

  @Input()
  status = RegionFeatureStatus.AVAILABLE;

  @Output()
  statusChange = new EventEmitter<RegionFeatureStatus>();

  @ViewChild('disableModal')
  disableModal: TemplateRef<any>;

  available = true;
  forced    = false;

  constructor(
    private modal: ModalService,
    private translate: TranslateService,
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.status && changes.status.currentValue) {
      this.updateFlags();
    }
  }

  availableChanged() {
    if (!this.available) {
      this.available = true;
      this.openDisableFeatureConfirm();
    }

    this.updateStatus();
  }

  forcedChanged() {
    this.updateStatus();
  }

  updateFlags() {
    this.available = this.status.available;
    this.forced    = this.status.forced;
  }

  updateStatus() {
    if (this.available) {

      if (this.forced) {

        this.status = RegionFeatureStatus.FORCED;

      } else {

        this.status = RegionFeatureStatus.AVAILABLE;

      }

    } else {

      this.status = RegionFeatureStatus.NOT_AVAILABLE;

    }

    this.statusChange.emit(this.status);
  }

  openDisableFeatureConfirm() {
    this.modal.open({
      title: this.translate.instant('regions.form.modals.disable-feature.title'),
      content: this.disableModal,
      closeButton: {
        text: this.translate.instant('regions.form.modals.disable-feature.buttons.no')
      },
      validateButton: {
        type: 'primary',
        text: this.translate.instant('regions.form.modals.disable-feature.buttons.yes'),
      },
      size: 'sm'
    }).subscribe(() => {
      this.available = false;
      this.updateStatus();
    });
  }

}
